import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';

import { AuthenticationResult, InteractionRequiredAuthError } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private msalService: MsalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const activeAccount = this.msalService.instance.getActiveAccount();

    if(!activeAccount){
        return next.handle(req);
    }

    return from(this.getAccessToken()).pipe(
      switchMap(token => {
        //Agregamos el token al header Authorization
        const clonedReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        return next.handle(clonedReq);
      }),
      catchError(error => {
        console.error('Error en AuthInterceptor:', error);
        return throwError(() => error);
      })
    );

  }

  private async getAccessToken(): Promise<string> {
    const activeAccount = this.msalService.instance.getActiveAccount();
    if (!activeAccount) {
      throw new Error('No hay cuenta activa para obtener token');
    }

    const request = {
      scopes: [environment.appBackend.accessScope],
      account: activeAccount
    };

    try {
      const response:AuthenticationResult = await this.msalService.instance.acquireTokenSilent(request);
      return response.accessToken;

    } catch (error) {

      console.warn('acquireTokenSilent falló, intentando redirect:', error);
      if (error instanceof InteractionRequiredAuthError) {
        //Si el usuario debe interactuar (token expirado, etc.)
        this.msalService.instance.acquireTokenRedirect(request);
      }
      throw error;
    }
  }
}